<div class="main_content px-3 position-relative w-100">
  <div class="container-fluid py-3">
    <div class="title mb-2">
      <a
        (click)="addUserEmail(addEmail, 1, 1, null)"
        class="btn btn-success float-right"
        >Add Email</a
      >
      <h2 class="base_url review_list">Reviews Pending / Completed</h2>
    </div>
    <div class="white_box shadow p-3">
      <!-- <p>{{google_feedbacks[0]|json}}</p> -->
      <div
        class="d-flex align-items-center flex-wrap mb-3 gray_box"
        *ngIf="checkAdminStatus == 'Admin'"
      >
        <select name="" id="" (change)="unhide($event.target.value, 0)">
          <option value="">Un-Hide User</option>
          <option *ngFor="let name of hideAdminData" value="{{ name?.id }}">
            {{ name?.userName }}
          </option>
        </select>
        <div *ngFor="let name of subAdminData; let i = index">
          <div class="tabs_click">
            <div
              class="{{
                name?.pending_payment_count > 4 && name.is_show_red_name == 1
                  ? 'pending_count'
                  : ''
              }} overlay_box btn {{ flag == name?.id ? 'btn-success' : '' }}"
              (click)="getDataByUser(name?.id, name)"
            >
              <span class="tabName">{{ name?.userName }}</span>
            </div>
            <div>
              <a
                class="btn2"
                (click)="addUserEmail(updateEmail, name?.id, 2, name)"
              >
                <i class="fas fa-pencil"></i
              ></a>
            </div>
            <div>
              <a class="btn1" (click)="hideURL(name.id, 1)"
                ><i class="fa-regular fa-circle-xmark pending_count_del_btn"></i
              ></a>
            </div>
          </div>
        </div>
        <!-- <div class="overlay_box">not iterable</div> -->
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div *ngIf="is_clicked_name == 1">
                <div class="row">
                  <div class="col-md-1">
                    <a
                      href="{{ show_review_link }}"
                      class="float-left"
                      target="_blank"
                      style="color: black"
                      ><i
                        class="fa fa-exclamation-circle"
                        aria-hidden="true"
                      ></i
                    ></a>
                  </div>
                  <div class="col-md-10 text-center">
                    <span>{{ show_client_desc }}</span>
                  </div>
                  <div class="col-md-1">
                    <a
                      href="{{ share_link }}"
                      target="_blank"
                      class="float-right"
                      style="color: black"
                      ><i class="fa fa-dollar" aria-hidden="true"></i
                    ></a>
                  </div>
                </div>
              </div>
              <br />

              <div class="goo_bg">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">No.</th>
                      <th scope="col">Review</th>
                      <th scope="col">Name</th>
                      <th scope="col">Start</th>
                      <th scope="col">Completed</th>
                      <th scope="col">Action</th>
                      <th scope="col">Approval Status</th>
                      <th scope="col">Payment Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let feedback of google_feedbacks; let i = index"
                    >
                      <th
                        class="{{
                          feedback.is_circle == 1
                            ? 'numberCircle'
                            : 'notNumberCircle'
                        }}"
                        scope="row"
                        (click)="update_circle(feedback.id)"
                      >
                        {{ googlecoundata - i }}
                      </th>
                      <th scope="row">
                        <a
                          (click)="
                            sendsms(
                              phone,
                              feedback.id,
                              feedback.description,
                              feedback.review_link,
                              feedback
                            )
                          "
                        >
                          <i class="fa-solid fa-message">
                            <span> {{ feedback.smscount }}</span>
                          </i></a
                        >
                      </th>

                      <td>
                        {{ feedback.description?.substring(0, 20) }} &nbsp;
                        <a
                          (click)="
                            editReview(updateReviewDesc, feedback.id, feedback)
                          "
                          class="btn btn-info float-right"
                        >
                          <i class="fas fa-edit"></i
                        ></a>
                      </td>

                      <td>
                        {{
                          feedback.feedback_message_threes.length > 0
                            ? feedback.feedback_message_threes[0].name
                            : "-"
                        }}
                      </td>
                      <td>
                        <p *ngIf="feedback.sms_time != 0">
                          {{ feedback.sms_time * 1000 | date : "dd/MM/yyyy" }}
                        </p>
                        <p *ngIf="feedback.sms_time == 0">-</p>
                      </td>
                      <td>
                        <p *ngIf="feedback.completed_time != 0">
                          {{
                            feedback.completed_time * 1000 | date : "dd/MM/yyyy"
                          }}
                        </p>
                        <p *ngIf="feedback.completed_time == 0">-</p>
                      </td>

                      <td>
                        &nbsp;
                        <a
                          *ngIf="
                            feedback.is_verify == 0 &&
                            checkAdminStatus == 'subAdmin'
                          "
                          class="btn btn-danger"
                          >Pending</a
                        >
                        <a
                          (click)="imageUpload(imageInput, feedback.id)"
                          *ngIf="
                            feedback.is_verify == 0 &&
                            checkAdminStatus == 'Admin'
                          "
                          class="btn btn-danger"
                          >Pending</a
                        >
                        <a
                          (click)="viewlimage(viewImage, feedback.id)"
                          *ngIf="feedback.is_verify == 1"
                          class="btn btn-success"
                          >Completed</a
                        >
                      </td>

                      <td>
                        <p
                          class="text-center"
                          *ngIf="
                            feedback.is_approved == 0 &&
                            feedback.feedback_message_threes.length == 0
                          "
                        >
                          <i class="fas fa-check-circle"></i>

                          &nbsp;

                          <i class="fas fa-times-circle"></i>
                        </p>
                        <p
                          class="text-center"
                          *ngIf="
                            feedback.is_approved == 0 &&
                            feedback.feedback_message_threes.length > 0
                              ? feedback.feedback_message_threes[0]
                                  .is_approved == 0
                              : 0
                          "
                        >
                          <a
                            title="Approve"
                            (click)="
                              saveFeedbackApproval(
                                approve_disapprove_modal,
                                feedback.id,
                                1,
                                feedback.feedback_message_threes.length > 0
                                  ? feedback.feedback_message_threes[0]
                                  : {},
                                1
                              )
                            "
                          >
                            <i class="fas fa-check-circle"></i>
                          </a>
                          &nbsp;
                          <a
                            title="Un-Approve"
                            (click)="
                              saveFeedbackApproval(
                                approve_disapprove_modal,
                                feedback.id,
                                2,
                                feedback.feedback_message_threes.length > 0
                                  ? feedback.feedback_message_threes[0]
                                  : {},
                                1
                              )
                            "
                          >
                            <i class="fas fa-times-circle"></i>
                          </a>
                        </p>
                        <p
                          *ngIf="feedback.is_approved == 1"
                          class="text-center"
                        >
                          <i
                            class="fas fa-check-circle"
                            style="color: green"
                          ></i>
                          &nbsp;
                          <i class="fas fa-times-circle"></i>
                        </p>
                        <p
                          *ngIf="feedback.is_approved == 2"
                          class="text-center"
                        >
                          <a
                            title="Approve"
                            (click)="
                              saveFeedbackApproval(
                                approve_disapprove_modal,
                                feedback.id,
                                1,
                                feedback.feedback_message_threes.length > 0
                                  ? feedback.feedback_message_threes[0]
                                  : {},
                                1
                              )
                            "
                          >
                            <i class="fas fa-check-circle"></i>
                          </a>
                          &nbsp;
                          <i class="fas fa-times-circle" style="color: red"></i>
                        </p>
                      </td>

                      <td>
                        <p
                          class="text-center"
                          *ngIf="
                            feedback.is_paid == 0 &&
                            feedback.feedback_message_threes.length == 0
                          "
                        >
                          <i class="fas fa-check-circle"></i>

                          &nbsp;
                        </p>
                        <p
                          class="text-center"
                          *ngIf="
                            feedback.is_paid == 0 &&
                            feedback.feedback_message_threes.length > 0
                              ? feedback.feedback_message_threes[0].is_paid == 0
                              : 0
                          "
                        >
                          <a
                            title="Approve"
                            (click)="
                              saveFeedbackPayment(
                                approve_disapprove_payment_modal,
                                feedback.id,
                                1,
                                feedback.feedback_message_threes.length > 0
                                  ? feedback.feedback_message_threes[0]
                                  : {},
                                1
                              )
                            "
                          >
                            <i class="fas fa-check-circle"></i>
                          </a>
                        </p>
                        <p *ngIf="feedback.is_paid == 1" class="text-center">
                          <i
                            class="fas fa-check-circle"
                            style="color: green"
                          ></i>
                        </p>
                        <p *ngIf="feedback.is_paid == 2" class="text-center">
                          <i class="fas fa-times-circle" style="color: red"></i>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addEmail let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Add Sub-Admin Data</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>

    <div class="modal-body">
      <form [formGroup]="addEmailFG">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Please Enter name"
            formControlName="userName"
          />
          <ng-container *ngIf="submitted && addEmailFG_v.userName.errors">
            <p
              class="error-message-repair"
              *ngIf="addEmailFG_v.userName.errors.required"
            >
              Name is required!
            </p>
          </ng-container>

          <br />
          <input
            type="text"
            class="form-control"
            placeholder="Please Enter review link"
            formControlName="email"
          />
          <ng-container *ngIf="submitted && addEmailFG_v.email.errors">
            <p
              class="error-message-repair"
              *ngIf="addEmailFG_v.email.errors.required"
            >
              Review link is required!
            </p>
          </ng-container>

          <br />
          <select class="form-control" formControlName="no_of_review">
            <option value="" selected disabled>Select Review count</option>
            <option
              *ngFor="let count of createReviewLoop(reviewCountLimit)"
              value="{{ count }}"
            >
              {{ count }}
            </option>
          </select>
          <ng-container *ngIf="submitted && addEmailFG_v.no_of_review.errors">
            <p
              class="error-message-repair"
              *ngIf="addEmailFG_v.no_of_review.errors.required"
            >
              Review count is required!
            </p>
          </ng-container>
          <br />
        </div>
        <div class="text-center">
          <button class="btn btn-dark mx-auto" (click)="add_user_email_data()">
            Add
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateEmail let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Sub-Admin Data</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="updateEmailFG">
          <div class="form-group">
            <div>
              <a href="{{ share_link }}" target="_blank">Click to open</a>
              &nbsp; &nbsp;
              <i
                title="Click to copy"
                style="cursor: pointer"
                class="fa fa-clipboard"
                [cdkCopyToClipboard]="share_link"
                aria-hidden="true"
                (click)="copyToClipboardMessage()"
              ></i>
            </div>

            <br />
            <input
              type="text"
              formControlName="email"
              class="form-control"
              placeholder="Please Enter review link"
            />
            <ng-container *ngIf="submitted && updateEmailFG_v.email.errors">
              <p
                class="error-message-repair"
                *ngIf="updateEmailFG_v.email.errors.required"
              >
                Review link is required!
              </p>
            </ng-container>

            <br />
            <input
              type="text"
              formControlName="client_desc"
              class="form-control"
              placeholder=""
            />
            <ng-container
              *ngIf="submitted && updateEmailFG_v.client_desc.errors"
            >
              <p
                class="error-message-repair"
                *ngIf="updateEmailFG_v.client_desc.errors.required"
              >
                Description is required!
              </p>
            </ng-container>

            <br />
            <select class="form-control" formControlName="no_of_review">
              <option value="" selected disabled>Select Review count</option>
              <option
                *ngFor="let count of createReviewLoop(reviewCountLimit)"
                value="{{ count }}"
              >
                {{ count }}
              </option>
            </select>

            <br />
          </div>
          <div class="text-center">
            <button
              class="btn btn-dark mx-auto"
              (click)="update_user_email_data()"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #updateReviewDesc let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Review</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="editFG">
          <div class="form-group">
            <br />

            <textarea
              class="form-control"
              placeholder="Write feedback"
              formControlName="description"
              >{{ edit_google_feedbacks.description }}</textarea
            >
            <br />

            <input
              type="text"
              formControlName="client_remarks"
              class="form-control"
              placeholder="Please Enter client remarks"
            />
            <br />
            <input
              type="text"
              formControlName="user_remarks"
              class="form-control"
              placeholder="Please Enter user remarks"
            />
          </div>
          <div class="text-center">
            <button
              class="btn btn-dark mx-auto"
              (click)="update_edit_google_feedbacks()"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #phone let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Send SMS</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">X</a>
    </div>

    <form [formGroup]="send_Message">
      <div class="modal-body">
        <div class="mb-3">
          <label for="type">Phone Number</label>
          <select
            class="right-side form-control"
            #selectformnames
            (change)="onSelectName(selectformnames.value)"
          >
            <!-- <option value="">Select from Names</option> -->
            <option
              value="{{ data.phno }}"
              *ngFor="let data of getallname_unsent"
              [ngStyle]="{
                color:
                  data.isTimeExceed == 0
                    ? 'red'
                    : data.sms_sent_count > 0
                    ? 'blue'
                    : 'inherit'
              }"
            >
              {{ data.name }} ({{ data?.complete_count }})
            </option>
          </select>
          <div class="input-group">
            <input
              disabled
              id="type"
              type="text"
              class="form-control"
              placeholder="Please Enter Phone No"
              formControlName="phone"
              oninput="this.value = this.value.replace(/[^0-9|+]/g, '');"
            />
            <ng-container *ngIf="submitted && send_Message_v.phone.errors">
              <p
                class="error-message-repair"
                *ngIf="send_Message_v.phone.errors.required"
              >
                Phone is required!
              </p>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="sendMessage()" class="btn btn-success">Send</button>
      </div>
    </form>
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Inbox ID</th>
          <th scope="col">Name</th>
          <th scope="col">Phone Number</th>
          <th scope="col">Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let message of feedbackMessages">
          <td>{{ message.inboxId }}</td>
          <td>{{ message.name }}</td>
          <td>{{ message.phone }}</td>
          <td class="ngb_rate_td">{{ formateDate(message.created) }}</td>
          <td>{{ message.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #imageInput let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Upload image</h4>
    <a (click)="modal.dismiss('Cross click')"
      ><i class="fa fa-window-close" aria-hidden="true"></i
    ></a>
  </div>
  <div class="modal-body">
    <form [formGroup]="imageUploadForm">
      <p *ngIf="imagepreview != ''">
        <img loading="lazy"
          class="modal_sm_img"
          height="50"
          width="50"
          src="{{ imgUrl }}{{ imagepreview }}"
          alt=""
        />
      </p>
      <p *ngIf="imagepreview == ''">
        <input
          type="file"
          name=""
          id=""
          class="form-control"
          accept="image/*"
          (change)="onFileChanged($event)"
        />
      </p>
      <br />

      <br />

      <br />
      <div class="modal-footer">
        <button class="btn btn-success" (click)="verify_review_token()">
          Save
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #viewImage let-modal class="">
  <div class="modal-header">
    <h4 class="modal-title">View image</h4>
    <a (click)="modal.dismiss('Cross click')"
      ><i class="fa fa-window-close" aria-hidden="true"></i
    ></a>
  </div>
  <div class="modal-body text-center">
    <img loading="lazy" class="modal_sm_img" src="{{ imgUrl }}{{ imagepreview }}" alt="" />
    <br />
    <br />
    <form [formGroup]="imageUploadForm">
      <input
        type="file"
        name=""
        id=""
        class="form-control"
        accept="image/*"
        (change)="onFileChanged($event)"
      />
      <br />

      <div class="modal-footer">
        <button class="btn btn-success" (click)="verify_review_token()">
          Save
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #approve_disapprove_modal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Aprroval Status</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <h2>Are you sure want to {{ is_approved_message }}</h2>
      </div>
      <div class="text-center">
        <button
          class="btn btn-dark mx-auto"
          (click)="
            saveFeedbackApproval(
              approve_disapprove_modal,
              gfbid,
              is_approved,
              feedbackmessagesObj,
              2
            )
          "
        >
          Yes
        </button>
        &nbsp; &nbsp;
        <button
          class="btn btn-dark mx-auto"
          (click)="modal.dismiss('Cross click')"
        >
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #approve_disapprove_payment_modal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Payment Status</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <h2>Are you sure want to {{ is_paid_message }}</h2>
      </div>
      <div class="text-center">
        <button
          class="btn btn-dark mx-auto"
          (click)="
            saveFeedbackPayment(
              approve_disapprove_payment_modal,
              gfbid,
              is_paid,
              feedbackmessagesObj,
              2
            )
          "
        >
          Yes
        </button>
        &nbsp; &nbsp;
        <button
          class="btn btn-dark mx-auto"
          (click)="modal.dismiss('Cross click')"
        >
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>
